export const FETCH_GALLERY = 'fetch_gallery';
export const FETCH_SCROLLBOX = 'fetch_scrollbox';
export const FETCH_COLLECTION = 'fetch_collection';
export const POST_FEEDBACK = 'post_feedback';
export const FETCH_TEAM = 'fetch_team';
export const FETCH_SERVICE = 'fetch_service';
export const FETCH_CARS = 'fetch_cars';
export const FETCH_BAGGER = 'fetch_bagger';

/* TEST */
export const FETCH_FEEDBACK = 'fetch_feedback';

export const SAVE_CONTENTEDITABLE = 'save_contenteditable';



// WEBPACK FOOTER //
// ./src/redux/actions/type.js